smartspider question assignment (PDF)